// Public routes that should not redirect to login on auth errors
// Note: Product pages now use clean URLs like /{skuId}/{slug} which are catch-all routes
export const PUBLIC_ROUTES = ['/collection', '/p/', '/product-details', '/fc/', '/rc/'];

export const navbarTopMenu = [
  { name: "Be a Seller", link: "/be-a-seller" },
  { name: "Integrations", link: "" },
  { name: "Pricing", link: "/pricing" },
  { name: "Help Center", link: "/help-center" },
];

export const FooterContent = {
  about:
    "Importerr is India’s first AI-powered B2B cross-border sourcing platform",
  headOne: "Connect With Us",
  headTwo: "How It Works",
  headThree: "Get To Know Us",
  headFour: "Quick Links",
};

export const importerrContact = {
  address: "SECTOR-6, Noida",
  email: "contact@importerr.com",
  phone: "+91 7827842406",
};

export const FooterHowItWorks = [
  { name: "How Importerr Works", link: "/how-dropshiping-work" },
  { name: "Why work with us", link: "/why-work-with-importerr" }, 
  { name: "Be a Seller", link: "/be-a-seller" },
  { name: "Our Process", link: "/" }, 
  // { name: "investor", link: "/investor" }, 
  // { name: "seller", link: "/seller" }, 
];

export const FooterGetToKnowUs = [
  { name: "About Us", link: "/about-us" },
  { name: "Contact Us", link: "/contact-us" },
  { name: "Privacy Policy", link: "/privacy-policy" },
  { name: "Cookies Policy", link: "/cookies-policy" },
  // { name: "Delivery and Shipping Guide", link: "/delivery-and-shipping-guide" }, // temporarily hide this link
  { name: "Shipping Policy", link: "/shipping-policy" },
  { name: "Return & Refund Policy", link: "/return-refund-policy" },
  {name: "Cancel Policy", link: "/cancel-policy"},
  { name: "Terms Of Service", link: "/terms-and-conditions" },
];

export const FooterQuickLinks = [
  { name: "Seller Login", link: "/login" },
  { name: "Your Account", link: "/seller/dashboard" },
  { name: "Selling Guide", link: "/selling-guide" },
  { name: "Help", link: "/help-center" },
];

export const HowDropshippingWorkContent = {
  section_one_head: "How does 1-Piece work",
  section_one_para:
    "1-Piece is a selling model where an online store offers products for single-piece orders without holding bulk inventory. When a customer places an order, the store purchases the item from a supplier, who then ships it directly to the customer. This eliminates the need for upfront inventory investment and warehouse management, allowing for a wide product selection. However, it also means lower profit margins and less control over product quality and shipping. Effective 1-Piece selling requires careful supplier selection, strong customer service, and efficient order processing.",

  section_two_head: (
    <h1>
      Our knowledge <br /> your <span>success</span>
    </h1>
  ),
  section_two_para:
    "We are dedicated to sharing our extensive knowledge and expertise to propel your success forward. Through personalized solutions and unwavering support, we empower you to navigate and excel in the dynamic landscape of e-commerce. Partner with us to harness the full potential of your business, achieve sustained growth, and reach new heights of prosperity. Together, let's build a thriving future for your online venture.",
};
